import { useEffect, useMemo } from 'react'
import '../../business/components/CartModal.css'
import './PreOrderStockModal.css'

function PreOrderStockModal({ isOpen, items, onClose, onContinue }) {
  useEffect(() => {
    if (!isOpen) return
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [isOpen, onClose])

  const list = useMemo(() => (Array.isArray(items) ? items : []), [items])

  if (!isOpen) return null

  return (
    <div className="cart-modal-overlay" onMouseDown={() => onClose?.()} role="presentation">
      <div
        className="cart-modal pre-order-stock-modal"
        onMouseDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Доступен предзаказ"
      >
        <div className="cart-modal-header">
          <div className="cart-modal-title">
            Нет в наличии
            <span className="cart-modal-subtitle pre-order-stock-hint">
              Можно оформить предзаказ
            </span>
            <span className="cart-modal-subtitle">
              {list.length
                ? `${list.length} ${list.length === 1 ? 'товар' : list.length >= 2 && list.length <= 4 ? 'товара' : 'товаров'}`
                : 'Нет данных'}
            </span>
          </div>
          <button
            className="cart-modal-close"
            type="button"
            onClick={() => onClose?.()}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>

        <div className="cart-modal-body">
          {list.length === 0 ? (
            <div className="cart-modal-empty">Нет товаров для предзаказа.</div>
          ) : (
            <ul className="cart-modal-list">
              {list.map((it) => {
                const key = it.key ?? it.id
                const needed = Number(it.needed ?? it.quantity ?? 0)
                const available = Number(it.available ?? 0)
                return (
                  <li key={key} className="cart-modal-item">
                    <div className="cart-modal-item-left">
                      {it.image ? (
                        <img className="cart-modal-item-image" src={it.image} alt={it.name || ''} />
                      ) : (
                        <div className="cart-modal-item-image cart-modal-item-image--placeholder" />
                      )}
                      <div className="cart-modal-item-meta">
                        <div className="cart-modal-item-name">{it.name || 'Товар'}</div>
                        <div className="pre-order-stock-meta">
                          нужно: {needed} · в наличии: {available < 0 ? 0 : available} · предзаказ
                        </div>
                      </div>
                    </div>
                    <div className="cart-modal-item-right">
                      <div
                        className="cart-modal-qty-pill pre-order-stock-qty"
                        aria-label={`Нужно ${needed}`}
                      >
                        × {needed}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          )}
        </div>

        <div className="cart-modal-footer">
          <div className="cart-modal-footer-actions">
            <button
              className="cart-modal-buyBtn pre-order-stock-backBtn"
              type="button"
              onClick={() => onClose?.()}
            >
              Назад
            </button>
            <button
              className="cart-modal-buyBtn"
              type="button"
              onClick={() => onContinue?.()}
            >
              Продолжить
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PreOrderStockModal
